import { useEffect, useState } from 'react'
import { VStack } from '@astryxdesign/core/VStack'
import { Button } from '@/components/ui/button.tsx'
import { registerTenantServiceWorker } from './register.ts'
import { watchUpdates } from './watchUpdates.ts'

export function AppUpdateNotice() {
  const [ready, setReady] = useState(false)
  const [dismissed, setDismissed] = useState(false)
  useEffect(() => {
    let disposed = false
    let stop: (() => void) | undefined
    void registerTenantServiceWorker().then(registration => {
      if (disposed || registration === null) return
      stop = watchUpdates(registration, navigator.serviceWorker, () => { setReady(true) })
    })
    return () => { disposed = true; stop?.() }
  }, [])
  if (!ready || dismissed) return null
  return (
    <VStack className="safe-top sticky top-0 z-50 mx-auto w-full max-w-2xl px-4 pb-4">
      <VStack gap={3} role="status" className="min-w-0 rounded-3xl bg-card p-4 ring-1 ring-border">
        <p className="text-base font-semibold">Доступно обновление</p>
        <p className="text-sm text-muted-foreground">Сначала сохраните изменения. Обновление перезагрузит экран, но не удалит вход и записи.</p>
        <Button size="touch" onClick={() => {
          if (window.confirm('Обновить приложение? Несохранённые изменения на этом экране будут потеряны.')) window.location.reload()
        }}>Обновить</Button>
        <Button size="touch" variant="ghost" onClick={() => { setDismissed(true) }}>Обновить позже</Button>
      </VStack>
    </VStack>
  )
}
